import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
    >
      <g id="favicon">
        <g id="favicon_bg_rgb">
          <path
            d="M109.25,18.75c-24.99-24.99-65.52-24.99-90.51,0-24.99,24.99-24.99,65.52,0,90.51,25,24.99,65.52,24.99,90.51,0,24.99-24.99,25-65.51,0-90.51ZM105.69,40.06c-2.16,6.44-9.09,25.76-9.09,25.76-2.32,6.3-15.9,6.24-34.33,6.3,0,0,11.91-1.68,15.35-8.33,3.44-6.64,7.5-20.11,7.5-20.11-18.34,0-19.97,6.42-19.97,6.42,0,0-11.59,32.41-15.73,44.36-32.11,0-26.98-15.86-26.98-15.86l16.06-45.06h32.54l-2.17,6.49s2.65-6.49,20.59-6.49c0,0,18.39.08,16.23,6.52Z"
            fill="#fff"
            strokeWidth="0"
          />
        </g>
      </g>
    </svg>
  );
};

export default LogoIcon;
